module.exports = __webpack_public_path__ + "static/media/avatar2.1a884ca8.jpeg";